/* eslint-disable react/jsx-key */
import { createStyles, makeStyles, Theme } from '../../index';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { DraggableListItem } from './DraggableListItem';
import { DraggableListItemContainerProps } from './models/transferListProps.types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    blockDragAnimation: {
      '& + div': {
        transform: 'none !important',
      },
    },
    shrinkRole: {
      width: `${theme.spacing(41.25)}px !important`,
    },
  }),
);

export const DraggableListItemContainer = ({
  item,
  addItem,
  isAdded,
  index,
  itemIcon,
}: DraggableListItemContainerProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Draggable
      data-testid={'DraggableListItemContainer-component'}
      key={index}
      draggableId={item.title || 'BLANK'}
      index={index}
    >
      {(provided, snapshot) => (
        <>
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={snapshot.draggingOver === 'itemsAdded' ? classes.shrinkRole : ''}
          >
            <DraggableListItem itemIcon={itemIcon} item={item} addItem={addItem} isAdded={isAdded} />
          </div>
          {snapshot.isDragging && (
            <div className={classes.blockDragAnimation}>
              <DraggableListItem itemIcon={itemIcon} item={item} addItem={addItem} isAdded={isAdded} />
            </div>
          )}
        </>
      )}
    </Draggable>
  );
};
